<template>
  <LayoutContainer v-if="error">
    <LayoutH1
      class="text-center"
    >
      {{ t('pages.error.title') }}
    </LayoutH1>
    <div class="flex flex-col justify-center items-center my-10">
      <LayoutP class="mb-10 text-center">
        {{ error.statusCode }} {{ error.statusMessage }} <br><br> {{ t('pages.error.text', { email: data.ngo.email }) }}
      </LayoutP>
      <UButton
        :label="t('pages.error.toFrontpageButton')"
        @click="handleError"
      />
    </div>
  </LayoutContainer>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const handleError = () => clearError({ redirect: '/' })

const { data } = getData()

onMounted(() => {
  console.log(props.error)
})
</script>

<!--
https://nuxt.com/docs/guide/directory-structure/error
{
  statusCode: number
  fatal: boolean
  unhandled: boolean
  statusMessage?: string
  data?: unknown
  cause?: unknown
}
-->
